export default "__VITE_ASSET__DTtHuiin__"